<template>
  <div class="gauge-container">
    <div id="gauge"></div>
  </div>
</template>

<script>
  export default {
    name: "Gauge",
    props: {
      min: {
        type: Number,
        default: 5
      },
      max: {
        type: Number,
        default: 60
      },
      step: {
        type: Number,
        default: 5
      },
      start: {
        type: Number,
        default: 5
      }
    },
    mounted() {
      let self = this

      // Send out an emit to register the default value
      this.$emit('input', 5)

      $("#gauge").roundSlider({
        sliderType: "min-range",
        editableTooltip: false,
        radius: 105,
        width: 60,
        value: 5,
        handleSize: 60,
        handleShape: "circle",
        circleShape: "pie",
        startAngle: 315,
        min: this.min,
        max: this.max,
        step: this.step,
        tooltipFormat: function (args) {
          return args.value + "<span>minutes</span>";
        },
        beforeCreate: function () {
          this.options.radius = this.control.parent().width() / 2;

          this["_bind"]($(window), "resize", function () {
            var radius = this.control.parent().width() / 2;
            this.option("radius", radius);
          });
        },
        valueChange: function(value) {
          self.$emit('input', value.value)
        }
      })
    },
  }


</script>

<style lang="scss">
.gauge-container {
  max-width: 300px;
  margin: 0 auto;
  overflow: hidden;
}

#gauge {
  .rs-handle {
    height: 15px !important;
    width: 60px !important;
    margin: 0px 1px !important;
    border-radius: 0;
    background-color: #0000004a;
  }
  .rs-range-color  {
    background-color: #3D3DDE;
  }
  .rs-path-color  {
    background-color: #E2E8FF;
  }

  .rs-full .rs-tooltip {
    top: 47%;
  }
  .rs-tooltip-text {
    font-size: 53px;
    font-family: 'Roboto', sans-serif;
    color: #3D3DDE;
    font-weight: bold;

    span {
      display: block;
      font-size: 20px;
    }
  }
  .rs-border {
    border: 0;
  }
}
</style>